import { render, staticRenderFns } from "./ArrayCheckbox.vue?vue&type=template&id=71246398"
import script from "./ArrayCheckbox.vue?vue&type=script&lang=js"
export * from "./ArrayCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports